import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector';
import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc';
import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds';
const responseLenses = getResponseLenses(GET_PROJECT);
const { viewLevel } = responseLenses;
export const projectDareLevelMinutesSelector = (state, props) => {
    return viewLevel(getRecordSelector(state, props));
};
